<div
  class="wp-type"
  tooltipPosition="bottom"
  [attr.size]="size()"
  [pTooltip]="wpType.name"
  [ngClass]="labelClasses"
  [ngStyle]="{ color: wpType.color }"
  [tooltipDisabled]="(showLabel && wpType.name.length < 8) || !showTooltip">
  <svg-icon
    [size]="size() !== 'xs' ? size() : 'sm'"
    [ngStyle]="{ backgroundColor: wpType.color }"
    [key]="castIcon | call: wpType.icon ?? defaultIcon" />

  <span
    *ngIf="showLabel"
    class="text">
    {{ wpType.name }}
  </span>
</div>
